<div class="context-box">
    <div class="progress"><mat-progress-bar mode="indeterminate" *ngIf="(loading$ | async)"></mat-progress-bar></div>

    <div class="title">Aufgaben</div>

    <input type="search" placeholder="Suche" ngModel (ngModelChange)="queryChanged($event)" />
    <div #taskScrollContainer style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
        <div *ngFor="let task of (tasks$ | async)" class="mb-2">
            <app-task [task]="task"></app-task>
        </div>
    </div>
    <app-task-form (submit)="addTask($event)"></app-task-form>

</div>
